/**
 * New charge search result item (Chirp). Shown when FT AWO_CHARGE_RESULTS is true.
 * Jira: https://chewyinc.atlassian.net/browse/CVC-35234
 */
const ChirpChargeSearchResultItem = () => <></>

export default ChirpChargeSearchResultItem
